import {PureComponent} from 'react';

import {react2panel} from 'common/util/react2panel';
import {withStyles} from 'common/util/react';

import {template} from './template';
import css from './index.module.styl?inline';

export class InProductUpsellModal extends PureComponent<EmptyObj, EmptyObj> {
  get config() {
    return {
      template,
    };
  }
}

// withStyles makes sure your React component has the styles wherever it's rendered (even if its under some other component's shadow dom)
export const InProductUpsellModalRct = withStyles(template, css);
export const InProductUpsellModalPanel = react2panel(`mp-in-product-upsell-modal`, InProductUpsellModalRct);
